var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconosparainterfazdepostulaciones11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.23 92.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        opacity: .78;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: #8390aa;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #737d8c;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.11,84.06c-20.93,0-37.96-17.03-37.96-37.96S27.18,8.13,48.11,8.13s37.96,17.03,37.96,37.96-17.03,37.96-37.96,37.96ZM48.11,12.66c-18.44,0-33.43,15-33.43,33.43s15,33.43,33.43,33.43,33.43-15,33.43-33.43S66.55,12.66,48.11,12.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.77,27.13v18.96c0,1.12.56,2.16,1.49,2.79l13.39,8.92c1.53,1.03,3.61.61,4.64-.93,1.03-1.55.61-3.61-.93-4.64l-11.89-7.92v-17.18c0-1.85-1.49-3.35-3.35-3.35s-3.35,1.49-3.35,3.35Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.11,84.06c-20.93,0-37.96-17.03-37.96-37.96S27.18,8.13,48.11,8.13s37.96,17.03,37.96,37.96-17.03,37.96-37.96,37.96ZM48.11,12.66c-18.44,0-33.43,15-33.43,33.43s15,33.43,33.43,33.43,33.43-15,33.43-33.43S66.55,12.66,48.11,12.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.77,27.13v18.96c0,1.12.56,2.16,1.49,2.79l13.39,8.92c1.53,1.03,3.61.61,4.64-.93,1.03-1.55.61-3.61-.93-4.64l-11.89-7.92v-17.18c0-1.85-1.49-3.35-3.35-3.35s-3.35,1.49-3.35,3.35Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconosparainterfazdepostulaciones11);
export default __webpack_public_path__ + "static/media/Iconos para interfaz de postulaciones-11.36a16d8d3c49e238304c2c32ff56cabb.svg";
export { ForwardRef as ReactComponent };